<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('get_prize_modal')">close</v-icon>
        <v-card-title class="display-1 mb-4">{{$t("Получить приз")}}</v-card-title>
        <v-card-text class="title mt-4">{{ chosen_prize.title }}</v-card-text>
        <v-layout mb-4 class="mt-3" align-center>
            <v-layout align-center>
                <div class="grey-text mr-4">{{$t("Баллы")}}: </div>
                <div class="headline">{{ chosen_prize.price }}</div>
            </v-layout>
            <iconLabel icon_name="idea" class="grey-text" size="15">{{ chosen_prize.theme }}</iconLabel>
        </v-layout>
        <v-card-actions>
            <v-layout wrap class="mt-3" align-end>
                <buttonRed class="flex xl3 lg4 md4 sm5 xs12"
                           :class="{'mr-0': $vuetify.breakpoint.xs, 'mb-2': $vuetify.breakpoint.smAndDown, 'mr-4': $vuetify.breakpoint.smAndUp}"
                           @click.native="order_prize(chosen_prize)"
                >Получить</buttonRed>
                <buttonBdWhite class="flex xl3 lg4 md4 sm5 xs12" :class="{'mb-2': $vuetify.breakpoint.sm}" @click.native="CLOSE_MODAL('get_prize_modal')">{{$t("Отмена")}}</buttonBdWhite>
                <v-dialog :value="prize_recieved_modal" persistent :width="$vuetify.breakpoint.mdAndUp ? 360 : 'auto'">
                    <prizeRecievedModal />
                </v-dialog>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import iconLabel from '@/components/ui/icons/icon_with_label';
import prizeRecievedModal from './Prize_received_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import api from './../../../../api/index';

export default {
  components: {
    buttonRed,
    buttonBdWhite,
    iconLabel,
    prizeRecievedModal,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('prize_shop', [
      'prizes_info_modal',
      'get_prize_modal',
      'prize_recieved_modal',
      'chosen_prize',
    ]),
  },
  methods: {
    ...mapMutations('prize_shop', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('prize_shop', [
      'order_prize',
    ]),
    // async get_prize(prize) {
    //   this.OPEN_MODAL('prize_recieved_modal');
    //   this.CLOSE_MODAL('get_prize_modal');
    //   this.SPEND_POINTS(prize.price);
    //   await api.prize_shop.order_prize(prize.id);
    // },
  },


};
</script>
